<template>
  <div class="audit">
    <div class="audit_top">
      <div class="inquire">
        <el-form :model="inquire_data">
          <el-form-item label="状态:">
            <el-select size="mini"
                       v-model="inquire_data.status"
                       placeholder="请选择状态">
              <el-option v-for="item in statusOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账单号:"
                        v-if="auditContent===0">
            <el-input v-model="inquire_data.payid"
                      size="mini"
                      placeholder="请输入账单号"></el-input>
          </el-form-item>
          <el-form-item label="申请类型:"
                        v-if="auditContent===0">
            <el-select v-model="inquire_data.type"
                       size="mini"
                       placeholder="请选择申请类型">
              <el-option v-for="item in typeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>

          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="inquire_data.mobile"
                      size="mini"
                      placeholder="根据手机号查询"></el-input>
          </el-form-item>
          <el-form-item label="用户名:">
            <el-input v-model="inquire_data.username"
                      size="mini"
                      placeholder="请输入用户名查询"></el-input>
          </el-form-item>
          <el-form-item label="时间段:">
            <!-- <el-input v-model="inquire_data.zdtime"
                      placeholder="请选择时间段"></el-input> -->
            <el-date-picker size="mini"
                            v-model="inquire_data.zdtime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            range-separator="-"
                            start-placeholder="开始"
                            end-placeholder="结束"
                            :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="inquire_btn">
        <el-button type="primary"
                   @click="inquireList">查 询</el-button>
        <el-button type="warning"
                   @click="reset_inquire">重 置</el-button>

      </div>
    </div>
    <div class="audit_main">
      <el-table :data="tableData"
                style="width: 100%"
                height="90%"
                :key="auditContent"
                :row-class-name="tableRowClassName"
                v-loading="loadingShow"
                border>
        <el-table-column label="状态"
                         width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==='0'?'':scope.row.status==='1'?'success':scope.row.status===-'1'?'danger':'warning'">
              {{scope.row.status==='0'?'待审核':scope.row.status==='1'?'通过审核':scope.row.status===-'1'?'拒绝申请':'错误'}}
            </el-tag>

          </template>
        </el-table-column>

        <el-table-column label="类型"
                         v-if="auditContent!==1"
                         width="100">
          <template slot-scope="scope">
            {{scope.row.type=='order'||scope.row.type=='soa'?'提现审核':scope.row.type=='fp'?'发票审核':'错误'}}
          </template>
        </el-table-column>

        <el-table-column label="申请时间"
                         width="200">
          <template slot-scope="prope">
            {{packaging_formatDate(prope.row.createtime)}}
          </template>
        </el-table-column>

        <el-table-column prop="username"
                         label="用户名"
                         width="120">
        </el-table-column>
        <el-table-column prop="numinfo"
                         v-if="auditContent!==1"
                         label="信息">
        </el-table-column>
        <el-table-column label="审核时间"
                         width="200">
          <template slot-scope="prope">
            {{packaging_formatDate(prope.row.endtime)}}
          </template>
        </el-table-column>
        <el-table-column label="审核备注">
          <template slot-scope="scope">
            {{scope.row.admininfo?scope.row.admininfo:'暂无'}}
          </template>
        </el-table-column>
        <el-table-column prop="amount"
                         label="金额"
                         v-if="auditContent!==1"
                         width="100">
        </el-table-column>

        <el-table-column prop="bakinfo"
                         label="备注信息">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top-start">
              <div slot="content"
                   v-html='scope.row.bakinfo'></div>
              <div v-html="scope.row.bakinfo"
                   class="oneShow"></div>
            </el-tooltip>

          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="btn_audit">
              <el-button type="primary"
                         @click="show_audit_dialog(scope.row)">审核</el-button>
            </div>
            <!-- <el-button type=""></el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :page-sizes="[10,20,30,40,50,60,70,80,90,100, 200, 300, 400]"
                     :page-size="pages"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="page_total">
      </el-pagination>
    </div>

    <el-dialog title="审核发票"
               :visible.sync="invoice_dialog"
               :before-close="handleClose"
               width="30%"
               class="audit_invoice">
      <div v-html="invoiceMinute"></div>
      <hr style="margin:10px 0 20px 0">
      <el-form :model="invoice_audit"
               ref="invoice_audit">

        <el-form-item label="选择审核状态:"
                      prop="status"
                      :rules="[
      { required: true, message: '审核状态不能为空',trigger: 'change'},
    ]">
          <el-select v-model="invoice_audit.status"
                     placeholder="请选择状态">
            <el-option v-for="item in withdrawal_audit_status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="输入审核备注:"
                      prop="remark"
                      :rules="[
      { required: true, message: '审核备注不能为空'},
    ]">
          <el-input v-model="invoice_audit.remark"
                    placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="invoice_dialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="invoice_audit_input('invoice_audit')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核提现"
               :visible.sync="withdraw_dialog"
               width="30%"
               :before-close="handleClose">
      <el-form :model="withdrawal_audit"
               ref="withdrawal_audit">
        <el-form-item label="选择审核状态:"
                      prop="status"
                      :rules="[
      { required: true, message: '审核状态不能为空',trigger: 'change'},
    ]">
          <el-select v-model="withdrawal_audit.status"
                     placeholder="请选择状态">
            <el-option v-for="item in withdrawal_audit_status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="输入审核备注:"
                      prop="remark"
                      :rules="[
      { required: true, message: '审核备注不能为空'},
    ]">
          <el-input v-model="withdrawal_audit.remark"
                    placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="withdraw_dialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="withdrawal_audit_input('withdrawal_audit')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="推广审核"
               :visible.sync="promotion_dialog"
               width="30%"
               :before-close="handleClose">

      <el-form :model="auditData"
               ref="auditData">
        <el-form-item label="选择审核状态:"
                      prop="zt"
                      :rules="[
      { required: true, message: '审核状态不能为空',trigger: 'change'},
    ]">
          <el-select v-model="auditData.zt"
                     placeholder="请选择状态">
            <el-option v-for="item in withdrawal_audit_status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="输入审核备注:"
                      prop="jionbak"
                      :rules="[
      { required: true, message: '审核备注不能为空'},
    ]">
          <el-input v-model="auditData.jionbak"
                    placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelUserAudit()">取 消</el-button>
        <el-button type="primary"
                   @click="detectionPromotion('auditData')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createLogger } from 'vuex'
import common from '@/assets/js/common'
import { apiAudit_invoice, apiAudit_withdraw, apiAudit_list, apiPromotionAudit } from '@/request/api'
export default {
  name: 'Audit',
  data () {
    return {
      // ------------当前审核的用户数据------------
      auditData: {
        id: '',
        zt: '',
        jionbak: ''
      },
      // ------------推广审核是否展示------------
      promotion_dialog: false,
      // ------------选择审核状态------------
      withdrawal_audit_status: [{
        value: '1',
        label: '已审核'
      }, {
        value: '0',
        label: '待审核'
      }, {
        value: '-1',
        label: '拒绝申请'
      }],
      // ------------表格加载动画------------
      invoiceMinute: '',
      // ------------表格加载动画------------
      loadingShow: false,
      // ------------时间选择器配置------------
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // ------------类型选择器------------
      typeOptions: [{
        value: 'fp',
        label: '发票'
      }, {
        value: 'order',
        label: '提现申请'
      }
        // , {
        //   value: 'mc',
        //   label: '用户'
        // }
      ],
      // ------------状态选择器------------
      statusOptions: [{
        value: '1',
        label: '已审核'
      }, {
        value: '0',
        label: '待审核'
      }, {
        value: '-1',
        label: '拒绝申请'
      }],


      // 当前审核内容
      auditContent: 0,


      // 发票审核
      invoice_audit: {
        status: '',
        remark: ''
      },
      // 提现的订单id
      invoice_audit_id: '',
      // 提现的订单id
      withdrawal_audit_id: '',
      // 提现审核
      withdrawal_audit: {
        status: '',
        remark: ''
      },
      //-----------------------------
      invoice_dialog: false,
      withdraw_dialog: false,
      // ----------------------------------
      tableData: [],
      page: 1,
      pages: 10,
      page_total: 10,
      // ----------------------------------
      inquire_data: {
        status: '',
        page: '',
        payid: '',
        type: '',
        mobile: '',
        username: '',
        zdtime: ''
      }
    }
  },
  methods: {
    // -------------检测推广申请审核是否填写完成-------------
    detectionPromotion (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.auditPromotion()
        } else {
          return false;
        }
      })
    },

    // -------------取消用户推广审核-------------
    cancelUserAudit () {
      this.promotion_dialog = false
      this.auditData = {
        id: '',
        zt: '',
        jionbak: ''
      }
    },
    // -------------确认用户推广审核-------------
    async auditPromotion () {
      let res = await apiPromotionAudit({
        pd: 'jion',
        jionbak: this.auditData.jionbak,
        zt: this.auditData.zt,
        id: this.auditData.id
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.promotion_dialog = false
        this.getPromotionAudit()
      } else {
        this.$message.error(res.message)
      }
    },
    // 查询判断
    inquireList () {
      if (this.auditContent === 0) {
        this.getAuditList()
      } else if (this.auditContent === 1) {
        this.getPromotionAudit()
      }
    },
    // 获取用户申请
    async getPromotionAudit () {
      this.loadingShow = true
      let res = await apiPromotionAudit({
        pd: "getlist",
        type: "mc",
        page: this.page,
        pageSize: this.pageSize,
        status: this.inquire_data.status,
        mobile: this.inquire_data.mobile,
        username: this.inquire_data.username,
        zdtime: this.inquire_data.zdtime !== '' ? JSON.stringify({ start: this.inquire_data.zdtime[0], end: this.inquire_data.zdtime[1] }) : ''
      })
      this.tableData = res.txlist
      this.page_total = parseInt(res.totalNum)
      this.loadingShow = false
    },
    // 切换为推广审核
    tabPromotionAudit (e) {
      this.auditContent = e
      this.page = 1
      this.tableData = []
      this.page_total = 0
      this.inquire_data = {
        status: '',
        page: '',
        payid: '',
        type: '',
        mobile: '',
        username: '',
        zdtime: ''
      }
      if (e === 0) {
        this.getAuditList()
      } if (e === 1) {
        this.getPromotionAudit()
      }
    },
    // 确定发票审核
    async confirm_audit_invoice () {
      let res = await apiAudit_invoice({
        fpbak: this.invoice_audit.remark,
        zt: this.invoice_audit.status,
        id: this.invoice_audit_id
      })
      common.returnData(this, res.errno, res.message)
    },
    //确定发票审核输入完成
    invoice_audit_input (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirm_audit_invoice()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //确定提现审核输入完成
    withdrawal_audit_input (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirm_audit_withdraw()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //确定提现审核
    async confirm_audit_withdraw () {
      let res = await apiAudit_withdraw({
        paybak: this.withdrawal_audit.remark,
        id: this.withdrawal_audit_id,
        zt: this.withdrawal_audit.status
      })
    },
    //展开审核
    show_audit_dialog (row) {
      if (row.type == 'order' || row.type == 'soa') {
        this.withdrawal_audit_id = row.id
        this.withdraw_dialog = true
      } else if (row.type == 'fp') {
        this.invoiceMinute = row.bakinfo
        this.invoice_audit_id = row.id
        this.invoice_dialog = true
      } else if (row.type == 'mc') {
        this.promotion_dialog = true
        this.auditData.id = row.id
      }
    },
    //判断审核类型变化样式
    tableRowClassName ({ row }) {
      if (row.type == 'order' || row.type == 'soa') {
        return 'withdraw_deposit'
      } if (row.type == 'fp') {
        return 'invoice_bg'
      }
    },
    //时间数据再封装
    packaging_formatDate (data) {
      if (!data) {
        return '暂无'
      }
      return common.formatDate(data)
    },
    // 重置
    reset_inquire () {

      this.inquire_data = {
        status: '',
        page: '',
        payid: '',
        type: '',
        mobile: '',
        username: '',
        zdtime: ''
      }

      this.getAuditList()
    },
    //条数发生变化
    handleSizeChange (e) {
      this.pages = e
      this.getAuditList()
    },
    //页码发生变化
    handleCurrentChange (e) {
      this.page = e
      this.getAuditList()
    },
    //获取账单列表数据
    async getAuditList () {
      this.loadingShow = true
      let res = await apiAudit_list({
        pd: 'getlist',
        pageSize: this.pages,
        page: this.page,
        status: this.inquire_data.status,
        payid: this.inquire_data.payid,
        type: this.inquire_data.type,
        mobile: this.inquire_data.mobile,
        username: this.inquire_data.username,
        zdtime: this.inquire_data.zdtime !== '' ? JSON.stringify({ start: this.inquire_data.zdtime[0], end: this.inquire_data.zdtime[1] }) : ''

      })
      if (res.errno == 0) {
        this.tableData = res.txlist
        this.page_total = parseInt(res.totalNum)
      }
      this.loadingShow = false

    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  },
  created () {
    this.getAuditList()
  }
}
</script>

<style lang="scss">
.oneShow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.audit {
  width: 100%;
  height: 100%;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  // background-color: pink;

  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .audit_top {
    width: 95%;
    min-height: 200px;
    // height: 20%;
    margin: 20px 0;
    background-color: #fff;
    .inquire {
      width: 100%;
      height: 70%;
      // background-color: pink;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .el-form {
        width: 95%;
        display: flex;
        justify-content: space-between;
        .el-form-item {
          min-width: 150px;
          max-width: 13%;
        }
      }
    }
    .inquire_btn {
      width: 95%;
      display: flex;
      justify-content: flex-end;
    }
  }
  .audit_main {
    width: 95%;
    height: 70%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-table {
      .btn_audit {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .withdraw_deposit {
        background: #ecf5ff;
      }
      .invoice_bg {
        background: #fdf6ec;
      }
      .cell {
        padding-left: 20px;
      }
    }
    .el-pagination {
      height: 10%;
      display: flex;
      align-items: center;
    }
  }
  .audit_invoice {
    .invoice_dialog_info {
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px solid #ccc;
      margin-bottom: 10px;
      .el-form-item {
        width: 30%;
        span {
          background-color: rgba(0, 0, 0, 0.027);
        }
      }
    }
  }
}
</style>